import { render } from "./show-doc-modal.vue?vue&type=template&id=6f2362e1&scoped=true"
import script from "./show-doc-modal.vue?vue&type=script&lang=js"
export * from "./show-doc-modal.vue?vue&type=script&lang=js"

import "./show-doc-modal.vue?vue&type=style&index=0&id=6f2362e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2362e1"]])

export default __exports__